module.exports = "<simple-crud service=\"products.service\" translations=\"products.translations\" fields=\"products.fields\"></simple-crud>"


//////////////////
// WEBPACK FOOTER
// ./client/app/manager/products/products.pug
// module id = 217
// module chunks = 0